import React from 'react'
import {FiPlus } from 'react-icons/fi'
import { requests } from './mock'

export const Suggestions = () => {
    return (
        <div className="user__suggestions">
            <h2 className="title-14">Suggestions</h2>

            {requests.map((data, i) => {
                return <div key={i} >
                    <div className="request" key={i}>
                        <div>
                            <img src={data.img} alt="" />
                            <h5 className="title">{data.title}</h5>
                            <p className="desc">{data.desc}</p>
                        </div>
                        <div className='add-button'>
                            <FiPlus size={19} />
                        </div>

                    </div>
                </div>
            })}
        </div>
    )
}

